import { BASE_URL } from "@services/api";
import { useConfig } from "@services/common/services";
import axios from "axios";

export const axiosInstanceBG = axios.create({
  baseURL: `${BASE_URL}/front-bg`,
});

axiosInstanceBG.interceptors.request.use(useConfig);
